import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import spIcon from "../../assets/brand/swlogo.png";
import spWordmark from "../../assets/brand/swletters.png";
import api from "../../api/api";
import { toast } from "react-toastify";


export const AddressProofUpload = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);

   const onSubmit = async () => {
    if (!file) return toast.warn("Select a file");
    try {
      setBusy(true);
      await api.kyc.uploadAddressProof(file);
      toast.success("Address proof uploaded");
      navigate("/");
    } catch (e) {
      toast.warn(e?.data?.message || e.message || "Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="w-[412px] [font-family:'Nunito',Helvetica] text-[#5d4037]">

        {/* Centered Logo */}
        <div className="w-full flex justify-center">
          <div className="inline-flex items-center gap-[0px] leading-none">
            <img
              src={spIcon}
              alt="Sweet Plate logo"
              className="shrink-0 select-none object-contain w-[100px] h-[86px] -mt-[2px]"
            />
            <img
              src={spWordmark}
              alt="Sweet Plate"
              className="shrink-0 select-none object-contain h-[50px] w-auto -ml-[4px]"
            />
          </div>
        </div>

        {/* Large Location Pi (TODO) */} 
        <div className="mt-6 w-full flex justify-center">
          <svg
            width="60"
            height="60"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Location pin"
            role="img"
          >
            {/* Pin */}
            <path
              fill="#5d4037"
              d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
            />
            {/* Base ring */}
            <ellipse
              cx="12"
              cy="21"
              rx="7"
              ry="2.2"
              fill="none"
              stroke="#5d4037"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>

        {/* Intro text */}
        <p className="w-[378px] mx-auto mt-6 text-[14px]">
          Upload a recent utility bill that contains the address of your business.
        </p>

        {/* Bullets */}
        <div className="w-[378px] mx-auto mt-4 space-y-3 text-[14px]">
          <div className="flex items-start gap-2">
            <span className="mt-1 inline-block w-2 h-2 rounded-full bg-[#5d4037]" />
            <span>Use a clear, well-lit photo.</span>
          </div>
          <div className="flex items-start gap-2">
            <span className="mt-1 inline-block w-2 h-2 rounded-full bg-[#5d4037]" />
            <span>Ensure all text is visible</span>
          </div>
          <div className="flex items-start gap-2">
            <span className="mt-1 inline-block w-2 h-2 rounded-full bg-[#5d4037]" />
            <span>Accepted formats: JPG, PNG, PDF (Max size: 5MB)</span>
          </div>
        </div>

      {/* Action boxes */}
      {/* File input */}
      <div className="w-[378px] mx-auto mt-5 space-y-2">
        <label className="block text-base font-semibold mb-2">Upload Address Proof</label>
        <div className="rounded-[12px] border-2 border-dashed border-[#5d4037] bg-[#fff8e1] p-4">
          <input
            type="file"
            accept=".jpg,.jpeg,.png,.pdf"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            className="block w-full text-sm text-[#5d4037] file:mr-3 file:py-2 file:px-4 file:rounded-[10px]
                       file:border file:border-[#5d4037] file:bg-white file:text-[#5d4037] file:cursor-pointer"
          />
          {file && (
            <div className="mt-2 text-[12px] text-[#5d4037]/80">
              Selected: <span className="font-semibold">{file.name}</span>
            </div>
          )}
        </div>
      </div>

        {/* Note */}
        <p className="w-[378px] mx-auto mt-5 text-[14px]">
          Once uploaded, tap ‘Submit for Verification.’ Your
          details will remain private and secure.
        </p>

        {/* Submit */}
        <div className="w-[378px] mx-auto">
          <button
            type="button"
            onClick={onSubmit}
            disabled={!file || busy}
            className={`mt-6 w-[290px] h-[60px] mx-auto block rounded-[50px] bg-[#f7c945] font-bold text-[#5d4037] transition-opacity
              ${!file || busy ? "opacity-50 cursor-not-allowed" : "hover:opacity-90"}`}
          >
            {busy ? "Uploading…" : "Submit"}
          </button>

          {/* Optional: Back link to Address Proof if you want navigation here */}
          <button onClick={() => navigate("/")} className="mt-3 text-sm underline">Skip For Now</button>
        </div>
      </div>
    </div>
  );
};
